import { render, staticRenderFns } from "./creative-blogger-form.vue?vue&type=template&id=b4bbc63e&scoped=true"
import script from "./creative-blogger-form.vue?vue&type=script&setup=true&lang=js"
export * from "./creative-blogger-form.vue?vue&type=script&setup=true&lang=js"
import style0 from "./creative-blogger-form.vue?vue&type=style&index=0&id=b4bbc63e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4bbc63e",
  null
  
)

export default component.exports